import React from 'react';
import PropTypes from 'prop-types';
import { hoursOfTheDayOptions } from 'utils/time';
import css from 'profile/ProfileDropdown.scss';
import Select from 'common/StyledSelect';
import { find } from 'lodash';
import classnames from 'classnames';
import { isEmptyString } from 'utils/text';

const HourlyDropdown = (props) => {
    return <Select id={props.id}
                   isSearchable
                   placeholder={props.placeholder}
                   ariaLabel={props.ariaLabel}
                   filterOption={props.filterOption}
                   className={classnames(css['dropdown'], {[props.className]: !isEmptyString(props.className)})}
                   isDisabled={props.isDisabled}
                   onChange={hour => props.onChange(hour.value)}
                   options={props.options}
                   value={find(props.options, ['value', props.value]) || null} />
};

HourlyDropdown.defaultProps = {
    isDisabled: false,
    options: hoursOfTheDayOptions,
};

HourlyDropdown.propTypes = {
    ariaLabel: PropTypes.string,
    className: PropTypes.string,
    id: PropTypes.string.isRequired,
    isDisabled: PropTypes.bool,
    options: PropTypes.array,
    filterOption: PropTypes.func,
    onChange: PropTypes.func.isRequired,
    placeholder: PropTypes.string,
    value: PropTypes.string
};

export default HourlyDropdown;
